module.exports = __webpack_public_path__ + "img/2023-01-09a_1.02489540.jpg";